import axiosClient from './axiosClient';

export interface Customer {
  customer_id: string;
  customer_code: string;
  customer_name: string;
  customer_description: string;
}

export interface Sponsor {
  sponsor_id: string;
  customer_id: string;
  sponsor_code: string;
  sponsor_name: string;
  sponsor_description: string;
}

/**
 * Create platform customers / sponsors (org hierarchy above tenants).
 * Backend proxies to tenant-service create-customer / create-sponsor and
 * returns the created row with its service-assigned id + generated code.
 */
export const customerSponsorApi = {
  createCustomer: async (input: { customer_name: string; customer_description?: string }): Promise<Customer> => {
    const { data } = await axiosClient.post('/api/customers', input);
    return data;
  },

  createSponsor: async (input: {
    customer_id: string;
    sponsor_name: string;
    sponsor_description?: string;
  }): Promise<Sponsor> => {
    const { data } = await axiosClient.post('/api/sponsors', input);
    return data;
  },
};
